import { render, staticRenderFns } from "./HistoryUpdateTable.vue?vue&type=template&id=54042264&scoped=true&"
import script from "./HistoryUpdateTable.vue?vue&type=script&lang=js&"
export * from "./HistoryUpdateTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54042264",
  null
  
)

export default component.exports